import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IFlightOperator } from 'src/models/flight-operator.model';
import services from 'src/services/flight-operator.service';

export const actionTypes = {
  FLIGHT_OPERATOR_FETCH: 'FLIGHT_OPERATOR_FETCH',
  FLIGHT_OPERATOR_ADD: 'FLIGHT_OPERATOR_ADD',
  FLIGHT_OPERATOR_UPDATE: 'FLIGHT_OPERATOR_UPDATE',
  FLIGHT_OPERATOR_DELETE: 'FLIGHT_OPERATOR_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.FLIGHT_OPERATOR_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.FLIGHT_OPERATOR_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.FLIGHT_OPERATOR_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.FLIGHT_OPERATOR_DELETE,
    service: services.itemDELETE,
  },
};

export type IFlightOperatorAsync = typeof asyncActions;
export interface IFlightOperatorState
  extends ICommonState<IFlightOperatorAsync> {
  data?: IFlightOperator;
  list: IFlightOperator[];
  total: number;
}

export const defaultState: IFlightOperatorState = {
  status: {},
  list: [],
  total: 0,
};

const FlightOperatorReducer = (
  state: IFlightOperatorState = defaultState,
  action: IReducerAction<IFlightOperatorAsync>
): IFlightOperatorState => {
  switch (action.type) {
    case actionTypes.FLIGHT_OPERATOR_FETCH: {
      return {
        ...state,
        list: action.payload?.operators.rows ?? [],
        total: action.payload?.operators.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default FlightOperatorReducer;
